module.exports = __webpack_public_path__ + "Wireframes14.png?e326455c544f104c50f6e8f7b19c3aea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes14.png
// module id = 113
// module chunks = 0